import Layout from "../views/Layouts/DashboardLayout.vue";
import Empty from "../views/Layouts/Empty.vue";

import ListPackage from "../views/Package/Package/ListPackage.vue";
import ListKeyword from "../views/Package/Keyword/ListKeyword.vue";

export default {
  path: "/packages",
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      path: "",
      redirect: "/packages/management"
    },
    {
      path: "management",
      name: "Package Management",
      component: ListPackage
    },
    {
      path: "keywords",
      component: Empty,
      children: [
        {
          path: "",
          name: "Keywords",
          component: ListKeyword
        }
      ]
    },
  ]
};
